<template>

  <v-expansion-panels
    v-model="expandState"
    multiple
    class="mb-1"
  >
    <v-expansion-panel >

      <v-expansion-panel-header color="secondary" dark dense>
        <v-icon class="ids-expansion-header-left-icon pr-2">
          mdi-flag
        </v-icon>
        {{headerText}}
      </v-expansion-panel-header>

      <v-expansion-panel-content>

        <!-- select box -->
        <v-container
          class="mlr-2"
          fluid
        >
          <v-row no-gutters>

            <v-progress-circular
              v-if="loading"
              class="mt-3 ids-geo-sel-loading"
              style=""
              indeterminate
              color="primary"
            />

            <v-select
              class="ml-3"
              ref="selectEl"
              :items="geoList"
              v-model="dataSelection"
              item-text="name"
              outlined
              :placeholder="placeHolderText"
              return-object
              @change="onUserChange"
            ></v-select>

          </v-row>

        </v-container>
        <!-- END select box -->

      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

</template>

<script>

export default {
  name: 'ids-country-selector',
  props: {
    geoType: { type: String, required: true },
    headerText: { type: String, required: true },
    placeHolderText: { type: String, required: false },
    geoList: { type: Array, required: true },
    selection: { type: Object, required: false, default: null },
    loading: { type: Boolean, required: false, default: false }
  },
  data () {
    return {
      expandState: [0], // expand the content by default
      dataSelection: JSON.parse(JSON.stringify(this.selection))
    }
  },
  methods: {
    onUserChange (newSelected) {
      // inform parent component
      this.$emit('ids-geo-selection-change', this.geoType, newSelected);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .v-expansion-panel-header > .ids-expansion-header-left-icon {
    /* ensure icon in expansion-header is left */
    flex: 0;
  }

  /* positions the loading indicator to the right of the select box */
  .ids-geo-sel-loading {
    position: absolute;
    right: 45px;
  }

</style>



// WEBPACK FOOTER //
// app/ids/components/filter/IdsGeoSelector.vue